(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('result-series', {
            parent: 'entity',
            url: '/result-series?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.resultSeries.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/result-series/result-series.html',
                    controller: 'ResultSeriesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('resultSeries');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('result-series-detail', {
            parent: 'entity',
            url: '/result-series/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.resultSeries.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/result-series/result-series-detail.html',
                    controller: 'ResultSeriesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('resultSeries');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ResultSeries', function($stateParams, ResultSeries) {
                    return ResultSeries.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('result-series.new', {
            parent: 'result-series',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/result-series/result-series-dialog.html',
                    controller: 'ResultSeriesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('result-series', null, { reload: true });
                }, function() {
                    $state.go('result-series');
                });
            }]
        })
        .state('result-series.edit', {
            parent: 'result-series',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/result-series/result-series-dialog.html',
                    controller: 'ResultSeriesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ResultSeries', function(ResultSeries) {
                            return ResultSeries.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('result-series', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('result-series.delete', {
            parent: 'result-series',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/result-series/result-series-delete-dialog.html',
                    controller: 'ResultSeriesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ResultSeries', function(ResultSeries) {
                            return ResultSeries.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('result-series', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
